import { useState, Fragment } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";


export default function InfoIcon(props) {

    const { icon, title, withBubble, onClick, delay,reverse, size,style,className } = props

    const [mountBubble, setMountBubble] = useState(false)

    
    return <Fragment>
        <FontAwesomeIcon className={className} style={style} icon={icon} title={title} size={size}  onClick={() => {
            if (onClick) {
                onClick()
            }
            if (withBubble) {
                setMountBubble(!mountBubble)
                setTimeout(() => {
                    setMountBubble(false)
                }, delay ?? 5000)
            }
        }} />
        {' '}
        {withBubble && mountBubble &&
            <span className="info-bubble bg-info react" style={reverse?{transform: 'translate(-120%)'}:{}} >{title}</span>
        }

    </Fragment>
}
